import Immutable from 'immutable'
import _ from 'lodash'
import {
  FETCH_DIAMONDS_REQUEST,
  FETCH_DIAMONDS_SUCCESS,
  FETCH_DIAMONDS_ERROR,
  GET_DIAMOND_REQUEST,
  GET_DIAMOND_SUCCESS,
  GET_DIAMOND_ERROR,
  SAVE_DIAMOND_REQUEST,
  SAVE_DIAMOND_SUCCESS,
  SAVE_DIAMOND_ERROR,
  CLEAR_DIAMOND_FIELD_ERROR,
  DELETE_DIAMOND_REQUEST,
  DELETE_DIAMOND_SUCCESS,
  DELETE_DIAMOND_ERROR,
  CREATE_DIAMOND,
  DELETE_DIAMOND_IMAGE_SUCCESS,
  CSV_UPLOAD_REQUEST,
  CSV_UPLOAD_SUCCESS,
  CSV_UPLOAD_ERROR,
  CLEAR_CSV_UPLOAD_RESULT,
  CLEAR_DIAMONDS,
  CLEAR_SELECTED_DIAMOND
} from '../actions/diamond'
import { Entity, Collection } from '../utils/jsonapi'
import { parseErrorResponse } from '../utils/errors'

export default (
  state = Immutable.Map({
    inProgress: false,
    diamonds: null,
    selectedDiamond: null,
    error: null,
    csvUploadResult: null
  }),
  action
) => {
  switch (action.type) {
    case FETCH_DIAMONDS_REQUEST:
    case GET_DIAMOND_REQUEST:
    case SAVE_DIAMOND_REQUEST:
    case DELETE_DIAMOND_REQUEST:
    case CSV_UPLOAD_REQUEST:
      return state.set('inProgress', true).set('error', null).set('csvUploadResult', null)
      return state.set('inProgress', true).set('error', null)
    case FETCH_DIAMONDS_ERROR:
    case GET_DIAMOND_ERROR:
    case SAVE_DIAMOND_ERROR:
    case DELETE_DIAMOND_ERROR:
    case CSV_UPLOAD_ERROR:
      return state
        .set('inProgress', false)
        .set('error', parseErrorResponse(action.error))
    case CLEAR_DIAMOND_FIELD_ERROR:
      const error = state.get('error')
      if (!error || !action.fieldName || !error[action.fieldName]) {
        return state
      }
      const fieldError = error[action.fieldName]
      const nextError = Object.assign({}, error)
      delete nextError[action.fieldName]
      if (Array.isArray(nextError.errors)) {
        nextError.errors = nextError.errors.filter(msg => msg !== fieldError)
      }
      if (_.isEmpty(nextError) || _.isEmpty(nextError.errors)) {
        delete nextError.errors
      }
      return state.set('error', _.isEmpty(nextError) ? null : nextError)
    case FETCH_DIAMONDS_SUCCESS:
      if (_.isFunction(action.callback)) {
        action.callback(action.diamonds)
      }
      return state.set('inProgress', false).set('diamonds', action.diamonds)
    case GET_DIAMOND_SUCCESS:
      return state
        .set('inProgress', false)
        .set('selectedDiamond', action.diamond)
    case SAVE_DIAMOND_SUCCESS:
      return state
        .set('inProgress', false)
        .set('diamonds', null)
        .set('selectedDiamond', action.diamond)
    case DELETE_DIAMOND_SUCCESS:
      return state
        .set('inProgress', false)
        .set('diamonds', null)
        .set('selectedDiamond', null)
    case CSV_UPLOAD_SUCCESS:
      return state
        .set('inProgress', false)
        .set('csvUploadResult', action.result)
    case CLEAR_CSV_UPLOAD_RESULT:
      return state.set('csvUploadResult', null)
    case CREATE_DIAMOND:
      return state.set(
        'selectedDiamond',
        new Entity({
          id: '',
          type: 'inventory',
          attributes: {
            statusCode: 1,
            setting: 'loose',
            mountType: 'center-stone',
            colorType: 'regular',
            price: '',
            currency: 'cad',
            shape: '',
            carat: '',
            cut: '',
            clarity: '',
            color: '',
            intensity: '',
            hue: '',
            certificate: '',
            certNum: '',
            markup: '',
            retailerName: '',
            retailerId: '',
            title: '',
            customTitle: '',
            internalId: '',
            jewelryCondition: 'new',
            jewelryType: '',
            brand: '',
            mountSize: '',
            metalType: '',
            metalPurity: '',
            totalWeightCarat: '',
            totalWeightGrams: '',
            parcelSize: 'single',
            saleMarkupType: 'none',
            salePrice: ''
          }
        })
      )
    case DELETE_DIAMOND_IMAGE_SUCCESS:
      const diamond = state.get('selectedDiamond').clone()
      diamond.removeRelated('images', action.image.id)
      return state.set('selectedDiamond', diamond)
    case CLEAR_DIAMONDS:
      return state.set('diamonds', null)
    case CLEAR_SELECTED_DIAMOND:
      return state.set('selectedDiamond', null)
    default:
      return state
  }
}
